import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from '@teem/app/app.routing';
import { AppComponent } from '@teem/app/app.component';

import { MainLayoutComponent } from '@teem/layouts/main-layout.component';
import { AddCityModalComponent } from '@teem/layouts/models/add-city-modal/add-city-modal.component';
import { AddStoreTypeModalComponent } from '@teem/layouts/models/add-store-type-modal/add-store-type-modal.component';
import { FreePlanExpiredModalComponent } from '@teem/layouts/models/free-plan-expired/free-plan-expired-modal.component';
import { TapIncreaseConsentModalComponent } from '@teem/layouts/models/tap-increase-consent/tap-increase-consent-modal.component';
import { HeaderComponent } from '@teem/layouts/header/header.component';
import { CartHeaderComponent } from '@teem/customer/header/cart-header.component';
import { UpgradeBanerComponent } from '@teem/layouts/upgrade-baner/upgrade-baner.component';
import { LoadingComponent } from '@teem/layouts/loading/loading.component';
import { AuthComponent } from '@teem/features/auth/auth.component';
import { CustomerComponent } from '@teem/customer/customer.component';
import { PromoVideoModalComponent } from '@teem/features/auth/modals/promo-video-modal/promo-video-modal.component';

import { DashboardModule } from '@teem/features/dashboard/dashboard.module';
import { InvoicesModule }from '@teem/features/invoices/invoices.module';
import { PaymentsModule }from '@teem/features/payments/payments.module';
import { SettlementsModule }from '@teem/features/settlements/settlements.module';
import { ExpensesModule } from '@teem/features/expenses/expenses.module';
import { QuotesModule } from '@teem/features/quotes/quotes.module';
import { ProposalsModule } from '@teem/features/proposals/proposals.module';
import { ClientsModule } from '@teem/features/clients/clients.module';
import { SettingModule } from '@teem/features/setting/setting.module';
import { TaxesModule } from '@teem/features/taxes/taxes.module';
import { UsersModule } from '@teem/features/users/users.module';
import { BillingModule } from'@teem/features/billing/billing.module';
import { SubscriptionPlanModule } from'@teem/features/subscription-plan/subscription-plan.module';
import { PendingPaymentsBannerComponent } from '@teem/layouts/pending-payments-banner/pending-payments-banner.component';
import { BranchesModule } from'@teem/web-market/store-branches/branches.module';
import { ZatcaPhaseTwoModule } from'@teem/features/zatca-phase-two/zatca-phase-two.module';

import { ProductsModule } from'@teem/web-market/products/products.module';
import { StoreServicesModule } from'@teem/web-market/store-services/store-services.module';
import { StoreInformationModule } from'@teem/web-market/store-information/store-information.module';
import { OrdersModule } from'@teem/web-market/orders/orders.module';
import { SigninModule } from '@teem/features/auth/signin/signin.module';
import { SignupModule } from '@teem/features/auth/signup/signup.module';
import { ForgotPasswordModule } from '@teem/features/auth/forgot-password/forgot-password.module';
// import { AuthModule } from '@teem/features/auth/auth.module';
import { WalletsModule } from'@teem/features/wallets/wallets.module';
import { StorefrontAnalyticsModule } from '@teem/features/storefront-analytics/storefront-analytics.module';
import { InfluencerAnalyticsModule } from '@teem/features/influence-analytics/influencer-analytics.module';
import { ProfitLossStatementsModule } from '@teem/profit-loss-statement/profit-loss-statement.module'; 


import { ProfileModule } from '@teem/customer/profile/profile.module';

import { TokenInterceptor } from '@teem/core/token.interceptor';
import { CoreModule } from '@teem/core/core.module';
import { SharedModule } from '@teem/shared/shared.module';
import { NiceSelectModule } from "ng-nice-select";

// import { AngularFireModule } from '@angular/fire';
// import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { environment } from '../environments/environment';
import { OrderPlacedModalComponent } from './layouts/models/order-placed-modal/order-placed-modal.component';
import { MonthlyInvoiceModule } from './features/monthly-invoice/monthly-invoice.module';

@NgModule({
    declarations: [
        AppComponent,
        AddCityModalComponent,
        AddStoreTypeModalComponent,
        FreePlanExpiredModalComponent,
        TapIncreaseConsentModalComponent,
        MainLayoutComponent,
        HeaderComponent,
        UpgradeBanerComponent,
        LoadingComponent,
        PendingPaymentsBannerComponent,
        AuthComponent,
        CartHeaderComponent,
        CustomerComponent,
        PromoVideoModalComponent,
        OrderPlacedModalComponent
    ],
    imports: [
        BrowserAnimationsModule,
        CommonModule,
        HttpClientModule,

        AppRoutingModule,

        // Other app modules
        CoreModule,
        SharedModule,

        // Feature modules
        DashboardModule,
        InvoicesModule,
        PaymentsModule,
        SettlementsModule,
        ExpensesModule,
        QuotesModule,
        ProposalsModule,
        ClientsModule,
        SettingModule,
        TaxesModule,
        UsersModule,
        BillingModule,
        OrdersModule,
        SubscriptionPlanModule,
        BranchesModule,
        ZatcaPhaseTwoModule,
        // AuthModule,
        SigninModule,
        SignupModule,
        ForgotPasswordModule,
        NiceSelectModule,

        ProductsModule,
        StoreServicesModule,
        StoreInformationModule,
        WalletsModule,
        StorefrontAnalyticsModule,
        InfluencerAnalyticsModule,
        ProfitLossStatementsModule,
        MonthlyInvoiceModule,
        ProfileModule,
        // AngularFireModule.initializeApp(environment.firebaseConfig),
        // AngularFireMessagingModule,

        FormsModule,
        ReactiveFormsModule,
        NgbModule
    ],
    providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TokenInterceptor,
          multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
